import { render } from "./SimulasiPesanan.vue?vue&type=template&id=7abc37ae&scoped=true"
import script from "./SimulasiPesanan.vue?vue&type=script&lang=js"
export * from "./SimulasiPesanan.vue?vue&type=script&lang=js"

import "./SimulasiPesanan.vue?vue&type=style&index=0&id=7abc37ae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/yohom_cp/yohom_cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abc37ae"]])

export default __exports__